<template>
<v-container fluid>

  <v-form ref="form" v-model="valid" :lazy-validation="lazy">    
    <v-text-field
      v-model="name"
      :rules="nameRules"
      :counter="50"
      label="Name"
      required
    ></v-text-field>
     <v-text-field
      v-model="lastname"
      :rules="lastnameRules"
      :counter="50"
      label="Lastname"
      required
    ></v-text-field>
    <v-text-field
      v-model="email"
      :rules="emailRules"
      label="E-mail"
      required
    ></v-text-field> 
    <v-text-field
      v-model="nif"
      :rules="documentRules"
      label="Id. Document Number"
      required
    ></v-text-field> 
    <v-btn :disabled="!valid" @click="submit">
      submit
    </v-btn>
    <v-btn @click="clear">clear</v-btn>
  </v-form>
  <v-snackbar
    v-model="isSnackBarVisible"
    :top=true
    :color="snackBarColor"
    :right=true
    :timeout=4000>
    {{ snackBarText }}
  </v-snackbar>
</v-container>
</template>

<script>
import axios from "axios";
//import { bodyAut } from "../utils/createLoginAutToken";
import { body } from "../utils/createJSON";
export default {
  props: ["scrollTop", "signatureType"],
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  beforeDestroy() {
    document.body.removeAttribute("class", "noscroll");
    window.scrollTo(0, this.scrollTop);
  },
  data: () => ({
    valid: true,
    lazy: false,
    name: "",
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 50) || "Name must be less than 50 characters"
    ],
    lastname: "",
    lastnameRules: [
      v => !!v || "Lastame is required",
      v => (v && v.length <= 50) || "Lastame must be less than 50 characters"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "E-mail must be valid"
    ],
    nif: "",
    documentRules: [
      v => !!v || "Id. document number is required"
      // v => /^[0-9\][A-Z]{9,12}$/.test(v) || "Id. document number must be valid"
    ],
    snackBarColor: "",
    snackBarText: "",
    isSnackBarVisible: false
  }),
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$ga.event({
          eventCategory: "VideoIdentification", // str
          eventAction: "click", // str
          eventLabel: "CreateButton", // str
          eventValue: 0 // int
        });
        // Native form submission is not yet supported
        axios
          .post(`${process.env.VUE_APP_BASEURL}${"login"}`, {
            username: "pablo",
            userpassword: "A6xnQhbz4Vx2HuGl4lXwZ5U2I8iziLRFnhP5eNfIRvQ="
          })
          .then(
            success => {
              this.$store.commit("setToken", success.data);
              let bodyData = Object;              
              bodyData = JSON.stringify(body());
              bodyData = bodyData.replace(
                "##signatureType##",
                "AVANZADA_VIDEO_1PASO"
              );
              bodyData = bodyData.replace("##nif##", this.nif);
              bodyData = bodyData.replace("##resumenif##", "Y");
              bodyData = bodyData.replace("##email##", this.email);
              bodyData = bodyData.replace("##name##", this.name);
              bodyData = bodyData.replace("##lastname##", this.lastname);
              bodyData = JSON.parse(bodyData);

              axios
                .post(
                  `${process.env.VUE_APP_BASEURL}${"create/withotpandtoken/"}${
                    this.$store.getters.domainUuid
                  }`,
                  bodyData
                )
                .then(
                  success => {
                    this.$store.commit(
                      "setESignToken",
                      success.data.loginautToken
                    );
                    this.$store.commit(
                      "setOperationUuid",
                      success.data.uuids[0]
                    );
                    this.$store.commit(
                      "setDocumentUuid",
                      success.data.documentsUuid[0]
                    );
                    this.getOperation();
                  },
                  () => {
                    this.snackBarColor = "error";
                    this.snackBarText =
                      "An error occurred creating the operation. Please, try again";
                    this.isSnackBarVisible = true;
                  }
                );
            },
            () => {
              this.snackBarColor = "error";
              this.snackBarText =
                "An error occurred creating the operation. Please, try again";
              this.isSnackBarVisible = true;
            }
          );
      }
    },
    getOperation() {
      axios
        .get(
          `${process.env.VUE_APP_BASEURL}${"getoperationbyuuid/"}${
            this.$store.getters.domainUuid
          }${"/"}${this.$store.getters.operationUuid}`
        )
        .then(
          success => {
            this.isLoading = false;
            this.$store.commit("setOperation", success.data);
            success.data.authPolicy.fields.forEach(element => {
              if (element.identifier === "cellphone") {
                this.$store.commit("setCellphone", element.value);
              }
              if (element.identifier === "signbox") {
                this.$store.commit("setSignBoxName", element.value);
              }
            });
            this.$store.commit(
              "setDocumentUuid",
              success.data.documents[0].documentUuid
            );
            this.$router.push({ name: "identificationSignature" });
          },
          () => {
            this.snackBarColor = "error";
            this.snackBarText =
              "An error occurred getting the operation data. Please try to create another one";
            this.isSnackBarVisible = true;
          }
        );
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>
